const GET_DEFAULT_SPECIFICATION_ITEM_SCHEMES = () => {
  return [
    { id: "engine", key: "engine", icon: "car-engine" },
    { id: "gearbox", key: "gearbox", icon: "car-transmission" },
    { id: "drivetrain", key: "drivetrain", icon: "car-drive" }
  ];
};
const GET_DEFAULT_CONTAINER_PROPS = () => ({
  schemes: GET_DEFAULT_SPECIFICATION_ITEM_SCHEMES()
});
export {
  GET_DEFAULT_CONTAINER_PROPS,
  GET_DEFAULT_SPECIFICATION_ITEM_SCHEMES
};
